import { theme } from '@xometry/xometry_loft';
import type { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: theme.colors.blues[100],
    colorSuccess: theme.colors.greens[100],
    colorError: theme.colors.reds[100],
    colorWarning: theme.colors.yellows[100],
    colorTextBase: theme.colors.darkBlues[100],
    colorBgBase: '#ffffff',
    borderRadius: 4,
    fontFamily: 'inherit',
  },
};

/**
 * Loft theme color tokens extended with extra `grays` keys.
 *
 * Loft's `grays` is a 0–8 indexed array. Code that references
 * grays[25], grays[50], etc. resolves to `undefined` at runtime.
 * We extend those keys with darkBlues values so migrated components
 * render correctly.
 */
export const loftColors = {
  grays: {
    ...(theme.colors.grays as unknown as Record<number, string>),
    25: theme.colors.darkBlues[25],
    50: theme.colors.darkBlues[50],
    75: theme.colors.darkBlues[75],
    100: theme.colors.darkBlues[100],
  } as Record<number, string>,

  blues: { ...theme.colors.blues } as Record<number, string>,
  greens: { ...theme.colors.greens } as Record<number, string>,
  reds: { ...theme.colors.reds } as Record<number, string>,
  yellows: { ...theme.colors.yellows } as Record<number, string>,
  darkBlues: { ...theme.colors.darkBlues } as Record<number, string>,
};

export const loftFontWeights = { ...theme.fontWeights };
